export const checkMinMax = () => {
    const is_gsc_report = window.gsc_report || window.location.pathname.includes('gsc-reports');
    const domainId = window.location.pathname?.split('/')?.[2];

    const min_max = window.localStorage.getItem(
        is_gsc_report ? 'search-summary-min-max-date' : 'global-min-max-date',
    );
    if (!min_max) {
        window.minMaxDates = null;
        return;
    }

    let minmaxData = JSON.parse(min_max);
    let item = minmaxData?.[domainId];
    if (!item?.createdAt) return;
    const date = new Date(item.createdAt);
    // check for one hour
    const hoursAgo = new Date(Date.now() - 1 * 60 * 60 * 1000);

    if (date < hoursAgo || !item?.data?.mindate || !item?.data?.maxdate) {
        window.minMaxDates = null;
        minmaxData[domainId] = null;

        window.localStorage.setItem(
            is_gsc_report ? 'search-summary-min-max-date' : 'global-min-max-date',
            JSON.stringify(minmaxData),
        );
        return;
    }
    window.minMaxDates = item.data;
};
